export default {
  toggledUsername: 'Toggled username switch',
  changedAvatar: 'Changed default avatar',
}
